// Used inside /ui_user/activities and /ui_user/message_form/activities
// This is only used inside the Messages page and then Connection page "Messages" tab.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sentMessage"]
  static values = {
    circleId: Number,
    targetId: Number
  }

  connect() {
    if (!this.hasSentMessageTarget) {
      requestAnimationFrame(() => {
        // The observer handles the async timing between tab switching and content visibility for the Messages page
        // All the other panels have display:none on the element so we don't scroll content to the bottom until it is visible on the DOM
        const observerCallback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isVisible) {
              const logElement = this.getLogElement();
              if (logElement && logElement.children.length > 0) {
                this.scrollToBottomOnPageLoad();
                observer.unobserve(entry.target);
              }
            }
          });
        };

        const observer = new IntersectionObserver(observerCallback, {trackVisibility: true, delay: 100});
        observer.observe(this.element);
      });
    }
  }

  getLogId() {
    if (this.hasCircleIdValue && this.circleIdValue) {
      return `log-circle-${this.circleIdValue}`;
    } else if (this.hasTargetIdValue && this.targetIdValue) {
      return `log-target-${this.targetIdValue}`;
    }
  }

  getLogElement() {
    return document.getElementById(this.getLogId())
  }

  scrollToBottomOnPageLoad() {
    const activities = this.element.closest('.activities');
    if (activities) {
      activities.scrollTop = activities.scrollHeight;
    }
  }

  // For message submission, pin scroll to the bottom to display the new message
  pinScrollToBottom() {
    if (this.hasSentMessageTarget) {
      const config = { childList: true };

      const callback = (mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList") {
            const parent_container = this.element.closest('.chat-message-form-container');
            const activities_container = parent_container.querySelector('.activities');

            activities_container.scrollTo(0, activities_container.scrollHeight);
            observer.disconnect();
          }
        }
      };

      const observer = new MutationObserver(callback);
      const logElement = this.getLogElement();
      if (logElement) {
        observer.observe(logElement, config);
      }
    }
  }
}